module.exports = __webpack_public_path__ + "img/early-warning-disarmed.8d04232c.svg";